import React, { useState } from 'react';
import { IconDownload, IconPlus } from '../../../../common/icons';
import ContainerTabs from '../ContainerTabs';
import Pagination from '../../../../common/pagination';
import StaticTableContent from './elements/StaticTableContent';
import AddContainerType from './elements/AddContainerType';
import SettingsTab from '../../common-elements/SettingsTabs';

const ContainerType = () => {
  const [showNewTypeModal, setShowNewTypeModal] = useState(false);

  const handleShowNewTypeModal = (event) => {
    setShowNewTypeModal(true);
  };

  const handleHideNewTypeModal = (event) => {
    setShowNewTypeModal(false);
  };
  return (
    <div className="position-relative subheader-wrapper">
      <div className="subheader">
        <div className="subheader__inner d-flex align-items-center py-0">
          <SettingsTab
            activeTab={5}
            button={
              <div className="d-flex">
                <button className="mr-2 btn btn-outline-light ">
                  <IconDownload className="mr-2" />
                  Downlaod CVS
                </button>
                <button className=" btn btn-success ">
                  <IconPlus className="mr-2" />
                  Add Customers
                </button>
              </div>
            }
          />
        </div>
      </div>
      <div className="page-fluid">
        <div className="top-page">
          <div className="pb-15 d-flex align-items-center justify-content-between">
            <ContainerTabs
              activeTab={'Type'}
              button={
                <button
                  className="ml-auto btn btn-success"
                  onClick={handleShowNewTypeModal}
                >
                  <IconPlus className="mr-2" />
                  Add New Type
                </button>
              }
            />
          </div>
          <div className="pb-15 d-flex align-items-center justify-content-between">
            <h4 className="font-20 mb-0">10 Container Types</h4>
            <Pagination />
          </div>
        </div>

        {/* Static table Content */}
        <StaticTableContent />
      </div>
      {/* Add New Pricing */}
      {showNewTypeModal && (
        <AddContainerType
          onCancel={handleHideNewTypeModal}
          onSubmit={handleHideNewTypeModal}
        />
      )}
    </div>
  );
};

export default ContainerType;
